import { useLocation, useNavigate } from 'react-router-dom';

export default function useInsightsHubReturn() {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    // React Router marks an entry with no in-app history to pop as 'default'.
    if (location.key !== 'default') navigate(-1);
    else navigate('/research-hub');
  };
}
